// @flow
import React from 'react'
import AddIcon from '../../../../master/components/icons/AddIcon'
import RemoveIcon from '../../../../master/components/icons/RemoveIcon'
import {
  Wrapper,
  ImageWrapper,
  ContentWrapper,
  Title,
  DataWrapper,
  InputWrapper,
  Label,
  Button,
  AddButton
} from './styles'

type Props = {
  addToCart: Function,
  id: number,
  image: {
    large: string
  },
  name: string,
  numItems: number,
  price: string,
  cartID: number,
  addButtonText?: string
}

const ProductItem = (props: Props) => (
  <Wrapper>
    <ImageWrapper>
      <img src={props.image.large || props.image} alt={props.name} />
    </ImageWrapper>
    <ContentWrapper>
      <Title>{props.name}</Title>
      <DataWrapper>
        <InputWrapper>
          <Label>{`${props.price}`}</Label>
          <Label>{`${props.numItems ? 'x' + props.numItems : ''}`}</Label>
        </InputWrapper>

        {props.addButtonText && !props.numItems ? (
          <AddButton
            onClick={() =>
              props.addToCart(props.id, props.cartID, props.numItems + 1)
            }
          >
            {props.addButtonText}
          </AddButton>
        ) : (
          <>
            <Button
              onClick={() =>
                props.addToCart(props.id, props.cartID, props.numItems - 1)
              }
            >
              <RemoveIcon />
            </Button>
            <Button
              onClick={() =>
                props.addToCart(props.id, props.cartID, props.numItems + 1)
              }
            >
              <AddIcon />
            </Button>
          </>
        )}
      </DataWrapper>
    </ContentWrapper>
  </Wrapper>
)

export default ProductItem
